'use client';

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '../../utils/cn/cn';

const Slider = React.forwardRef<
  React.ComponentRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => {
  const sliderId = React.useId();
  const { defaultValue, value, disabled } = props;
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        `group ${disabled ? 'slider-disabled' : ''} relative flex w-full touch-none items-center select-none`,
        className,
      )}
      {...props}
    >
      <SliderPrimitive.Track className="bg-color-grey relative h-0.5 w-full grow overflow-hidden rounded-full group-[.slider-disabled]:opacity-35">
        <SliderPrimitive.Range className="bg-color-primary absolute h-full" />
      </SliderPrimitive.Track>
      {value || defaultValue ? (
        (value || defaultValue)?.map((_, i) => (
          <SliderPrimitive.Thumb
            // blur on pointer up to prevent focus styles from sticking
            onPointerUp={(event) => {
              event.currentTarget.blur();
            }}
            // eslint-disable-next-line react/no-array-index-key
            key={`${sliderId}-${i}`}
            asChild
          >
            <span className="m-0.5 flex">
              <span className="focus-visible:shadow-slider-thumb bg-color-primary block h-2 w-2 shrink-0 cursor-pointer rounded-full shadow-xs transition-colors group-[.slider-disabled]:opacity-35 group-[.slider-disabled]:shadow-none focus-visible:outline-hidden disabled:pointer-events-none disabled:cursor-default" />
            </span>
          </SliderPrimitive.Thumb>
        ))
      ) : (
        <SliderPrimitive.Thumb onPointerUp={(event) => event.currentTarget.blur()} asChild>
          <span className="m-0.5 flex">
            <span className="focus-visible:shadow-slider-thumb bg-color-primary block h-2 w-2 shrink-0 cursor-pointer rounded-full shadow-xs transition-colors group-[.slider-disabled]:opacity-35 group-[.slider-disabled]:shadow-none focus-visible:outline-hidden disabled:pointer-events-none disabled:cursor-default" />
          </span>
        </SliderPrimitive.Thumb>
      )}
    </SliderPrimitive.Root>
  );
});
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
